import { Label, Panel, TableRow, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { CommentsAndReferenceNumbers } from "./CommentsAndReferenceNumbers";
import { AutogenLayoutLoadTenderExpressEdiStopGrid } from "./autogen/AutogenLayoutLoadTenderExpressEdiStopGrid";
import { StringUtil } from "@mcleod/core";

export class LoadTenderExpressEdiStopGrid extends AutogenLayoutLoadTenderExpressEdiStopGrid {
    private locStopType: String;

    tableLtxStopGridOnRowExpand(event: TableRowExpansionEvent) {
        if ((event.target as TableRow).data != null) {
            const row = (event.target as TableRow).data;
            const expandedPanel = event.expandComponentParent as Panel;
            const commentsAndRefnos = expandedPanel.findComponentById("layoutCommentsAndReferenceNumbers") as CommentsAndReferenceNumbers;
            commentsAndRefnos.ediStopId = row.get("id");
        }
    }

    tableLtxStopGridOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        const stopTypeComponent = tableRow.findComponentById("labelStopType") as Label;
        const labelLocation = tableRow.findComponentById("labelLocation") as Label;

        if (row.get("stop_type") == "PU") {
            stopTypeComponent.text = "Pickup";
        }
        else if (row.get("stop_type") == "SO") {
            stopTypeComponent.text = "Delivery";
        }
        const labelArriveLate = tableRow.findComponentById("labelArriveLate") as Label;
        if (StringUtil.isEmptyString(labelArriveLate.text)) {
            const labelDash = tableRow.findComponentById("labelDash") as Label;
            labelDash.visible = false;
        }

        const locationID = tableRow.data.get("location_id");

        if(locationID != null) {
            labelLocation.quickInfoOverrideKeyValue = locationID;
        }

        const address2 = row.get("address2");
        const address2Label = (event.target as TableRow).findComponentById("labelAddress2") as Label;
        if (address2Label) {
            address2Label.visible = !StringUtil.isEmptyString(address2);
        }
    }

}
